<template>
  <div class="form-row">
    <div class="col-12 col-md-6 col-xl-3 mb-3 mb-xl-0">
      <h6 class="surcharge-col-title">Charge</h6>
      <b-input-group size="sm" class="mb-2">
        <b-input-group-prepend is-text class="surcharge-prepend">Other Surcharge:</b-input-group-prepend>
        <b-form-input type="text" maxlength="100" placeholder="Label shown on the bill" v-model="entry.chargeLabel" />
      </b-input-group>
      <b-input-group size="sm">
        <b-input-group-prepend is-text class="surcharge-prepend">Amount $</b-input-group-prepend>
        <b-form-input type="number" step="0.01" min="0" placeholder="0.00" v-model="entry.perUnitCharge" />      </b-input-group>
    </div>

    <div class="col-12 col-md-6 col-xl-3 mb-3 mb-xl-0">
      <h6 class="surcharge-col-title">Filter by Weight</h6>
      <b-input-group size="sm" class="mb-2">
        <b-input-group-prepend is-text class="surcharge-prepend">IF <i class="fa fa-balance-scale mx-1"></i> Weight &ge;</b-input-group-prepend>
        <b-form-input type="number" step="0.01" min="0" placeholder="No minimum" v-model="entry.weightMinimum" />
        <b-input-group-append is-text>{{ weightUnit }}</b-input-group-append>
      </b-input-group>
      <b-input-group size="sm">
        <b-input-group-prepend is-text class="surcharge-prepend">IF <i class="fa fa-balance-scale mx-1"></i> Weight &le;</b-input-group-prepend>
        <b-form-input type="number" step="0.01" min="0" placeholder="No maximum" v-model="entry.weightMaximum" />
        <b-input-group-append is-text>{{ weightUnit }}</b-input-group-append>
      </b-input-group>
    </div>

    <div class="col-12 col-md-6 col-xl-3 mb-3 mb-md-0">
      <h6 class="surcharge-col-title">Filter by Zone</h6>
      <b-input-group size="sm" class="mb-2">
        <b-input-group-prepend is-text class="surcharge-prepend">IF <i class="fa fa-map-marker mx-1"></i> Zone &ge;</b-input-group-prepend>
        <b-form-input type="number" step="1" min="0" placeholder="No minimum" v-model="entry.zoneMinimum" />
      </b-input-group>
      <b-input-group size="sm">
        <b-input-group-prepend is-text class="surcharge-prepend">IF <i class="fa fa-map-marker mx-1"></i> Zone &le;</b-input-group-prepend>
        <b-form-input type="number" step="1" min="0" placeholder="No maximum" v-model="entry.zoneMaximum" />
      </b-input-group>
    </div>

    <div class="col-12 col-md-6 col-xl-3">
      <h6 class="surcharge-col-title">Filter by Date</h6>
      <b-input-group size="sm" class="mb-2">
        <b-input-group-prepend is-text class="surcharge-prepend">IF <i class="fa fa-calendar mx-1"></i> Date &ge;</b-input-group-prepend>
        <b-form-datepicker
          :reset-button="true"
          v-model="entry.afterDate"
          size="sm"
          class="form-control flatpickr-input"
          placeholder="No start date"
        />
      </b-input-group>
      <b-input-group size="sm">
        <b-input-group-prepend is-text class="surcharge-prepend">IF <i class="fa fa-calendar mx-1"></i> Date &le;</b-input-group-prepend>
        <b-form-datepicker
          :reset-button="true"
          v-model="entry.beforeDate"
          size="sm"
          class="form-control flatpickr-input"
          placeholder="No end date"
        />
      </b-input-group>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    entry: {
      type: Object,
      required: true
    },
    weightUnit: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.surcharge-prepend >>> .input-group-text {
  min-width: 8.5rem;
}
.surcharge-col-title {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #73818f;
}
</style>
